<mat-tab-group>
  <mat-tab label="Details">
    <div class="container-fluid p-3">

      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="card mb-4">
            <div class="card-body">
              <h5 class="card-title mb-4">Account Subscription</h5>

              <mat-form-field class="mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Subscription</mat-label>
                <mat-select [(ngModel)]="account.subscription" name="published">
                  <mat-option *ngFor="let subscription of app.getSubscriptions()" [value]="subscription">{{ subscription }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="mb-2">
                <mat-slide-toggle [(ngModel)]="account.is_logbook" name="is_logbook">
                  Enable Digital Logbook Product
                </mat-slide-toggle>
              </div>

              <div class="mb-2">
                <mat-slide-toggle [(ngModel)]="account.enable_sms_notifications" name="enable_after_hours_notification">
                  Enable SMS Notifications
                </mat-slide-toggle>
              </div>

              <div class="mb-2">
                <mat-slide-toggle [(ngModel)]="account.hazard_verification" name="hazard_verification">
                  Enable Hazards & Risks Verification
                </mat-slide-toggle>
              </div>

              <div class="mb-2">
                <mat-slide-toggle [(ngModel)]="account.include_in_search_results" name="include_in_search_results" matTooltip="By enabling this option, this account will be shown publicly when other accounts admins search for contractors to add to their accounts.">
                  Include this account in search results.
                </mat-slide-toggle>
              </div>

              <div class="mb-2">
                <mat-slide-toggle [(ngModel)]="account.include_main_contact_in_notifications" matTooltip="When enabled, the main contact of this account will be included in all notifications." name="include_main_contact_in_notifications">
                  Include the main account contact in all notifications.
                </mat-slide-toggle>
                <mat-hint>When enabled, the main contact of this account will be included in all notifications.</mat-hint>
              </div>

              <div class="mb-0">
                <mat-slide-toggle [(ngModel)]="account.enable_manual_gps_signins" matTooltip="Enable this option to allow users to manually sign in using the ‘GPS Sign-in’ button in the mobile app." name="enable_manual_gps_signins">
                  Enable Manual GPS Sign-ins
                </mat-slide-toggle>
                <mat-hint>Enable this option to allow users to manually sign in using the ‘GPS Sign-in’ button in the mobile app.</mat-hint>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title mb-4">{{ account.id ? 'Update' : 'Add' }} Account</h5>

                <div class="row">
                  <div class="col">
                    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                      <mat-label>Account Name</mat-label>
                      <input
                        matInput
                        placeholder="Account Name"
                        [(ngModel)]="account.name"
                        name="name"
                        type="text"
                        #name
                        required />
                      <mat-hint>Enter the name of the organisation.</mat-hint>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                      <mat-label>Industry</mat-label>
                      <mat-select
                        [(ngModel)]="account.industry"
                        name="industry"
                        #industry>
                        <mat-option *ngFor="let industry of industries" [value]="industry.name">{{ industry.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col">
                    <app-timezone-select [timezoneInput]="account.timezone" (timezoneOutput)="getOutputTimezone($event)"></app-timezone-select>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                      <mat-label>Address</mat-label>
                      <input
                        matInput
                        placeholder="Address"
                        [(ngModel)]="account.address"
                        name="address"
                        type="text"
                        #address />
                      <mat-hint>Enter the address of the organisation.</mat-hint>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                      <mat-label>{{ utils.getLangTerm('accounts.form.suburb', 'Suburb') }}</mat-label>
                      <input
                        matInput
                        [placeholder]="utils.getLangTerm('accounts.form.suburb', 'Suburb')"
                        [(ngModel)]="account.suburb"
                        name="suburb"
                        type="text"
                        #suburb />
                      <mat-hint>Enter the {{ utils.getLangTerm('accounts.form.suburb', 'Suburb') }} of the organisation.</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="col">
                    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                      <mat-label>{{ utils.getLangTerm('accounts.form.city', 'City') }}</mat-label>
                      <input
                        matInput
                        [placeholder]="utils.getLangTerm('accounts.form.city', 'City')"
                        [(ngModel)]="account.city"
                        name="city"
                        type="text"
                        #city />
                      <mat-hint>Enter the {{ utils.getLangTerm('accounts.form.city', 'City') }} of the organisation.</mat-hint>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                      <mat-label>{{ utils.getLangTerm('accounts.form.postal_code', 'Postal Code') }}</mat-label>
                      <input
                        matInput
                        [placeholder]="utils.getLangTerm('accounts.form.postal_code', 'Postal Code')"
                        [(ngModel)]="account.postal_code"
                        name="postal_code"
                        type="text"
                        #postal_code />
                      <mat-hint>Enter the {{ utils.getLangTerm('accounts.form.postal_code', 'Postal Code') }} of the organisation.</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="col">
                    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                      <mat-label>Country</mat-label>
                      <input
                        matInput
                        placeholder="Country"
                        [(ngModel)]="account.country"
                        name="country"
                        type="text"
                        #country />
                      <mat-hint>Enter the country of the organisation.</mat-hint>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                      <mat-label>Currency</mat-label>
                      <mat-select
                        placeholder="Select Currency Code."
                        [(ngModel)]="account.currency_code"
                        name="currency_code"
                        id="currency_code"
                        required>
                        <mat-option *ngFor="let c of currencies" [value]="c.code">
                          <div class="currency-option">
                            <div class="currency-main">
                              <span class="currency-code">{{ c.code }}</span>&nbsp;
                              <span class="currency-symbol">{{ c.symbol }}</span>&nbsp;
                            </div>
                            <div class="currency-name">{{ c.name }}</div>
                          </div>
                        </mat-option>
                      </mat-select>
                      <mat-hint>Select the default currency for this account. This affects how asset costs are displayed and calculated.</mat-hint>
                    </mat-form-field>
                  </div>
                </div>

                <div class="d-flex justify-content-end flex-wrap">
                  <button
                    class="my-2 ml-3 mr-0"
                    type="button"
                    mat-raised-button
                    color="secondary"
                    [matBadge]="'' + (account.main_contact_id ? 1 : 0)"
                    [disabled]="inProgress"
                    (click)="onSelectMainContact()">
                    <mat-icon>person</mat-icon>
                    Main Contact
                  </button>

                  <button
                    class="my-2 ml-3 mr-0"
                    type="button"
                    mat-raised-button
                    color="secondary"
                    [disabled]="inProgress"
                    (click)="onResyncAccountInductons()">
                    <mat-icon>sync</mat-icon> Resync Account Inductions
                  </button>
                  <button
                    class="my-2 ml-3 mr-0"
                    type="button"
                    mat-raised-button
                    color="secondary"
                    [disabled]="inProgress"
                    (click)="onOpenCopyTemplates()">
                    <mat-icon>file_copy</mat-icon> Copy Templates
                  </button>

                  <button
                    class="my-2 ml-3 mr-0"
                    type="submit"
                    mat-raised-button
                    [disabled]="!f.valid || inProgress"
                    color="primary">
                    <mat-icon>save</mat-icon> Save
                  </button>
                </div>

              </div>
            </div>
          </form>

        </div>
      </div>

    </div>
  </mat-tab>
  <mat-tab label="{{ utils.getLangTerm('employees.plural', 'Employees') }}" *ngIf="account.id">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle Navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <span class="mr-auto">
          <button type="button" mat-raised-button color="secondary" (click)="onSelectUsers()" class="m-1 mr-2">
            <mat-icon>people</mat-icon> Select Users
          </button>
        </span>

        <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
          <input
            class="form-control ml-0 mr-2 my-1"
            type="search"
            [(ngModel)]="dataSource.search"
            name="search"
            placeholder="Search"
            aria-label="Search" />

          <button
            mat-raised-button
            color="secondary"
            type="submit"
            class="mx-0 my-1">
            <mat-icon>search</mat-icon> Search
          </button>
        </form>
      </div>
    </nav>

    <div class="scroll-box">

      <table mat-table [dataSource]="dataSource" matSort matSortActive="contact_person" matSortDirection="asc" matSortDisableClear>

        <ng-container matColumnDef="user_id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by ID">
            #
          </th>
          <td mat-cell *matCellDef="let user">
            {{ user.user_id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="icons">
          <th mat-header-cell *matHeaderCellDef>Status Icons</th>
          <td mat-cell *matCellDef="let element">
            <mat-icon
              matTooltip="Connected to the {{ utils.getAppName() }} mobile app{{ element.version ? (', using version ' + element.version) : ''}}."
              *ngIf="element.device_id">
              phonelink_setup
            </mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="contact_person">
          <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by full name">
            Full Name
          </th>
          <td mat-cell *matCellDef="let user">
            <a (click)="onRedirectToUser(user.user_id)">{{ user.contact_person }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by Email Address">
            Email Address
          </th>
          <td mat-cell *matCellDef="let user">
            {{ user.email }}
          </td>
        </ng-container>

        <ng-container matColumnDef="mobile">
          <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by {{ utils.getLangTerm('users.list.mobile', 'Mobile Number') }}">
            {{ utils.getLangTerm('users.list.mobile', 'Mobile Number') }}
          </th>
          <td mat-cell *matCellDef="let user">
            {{ user.mobile }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date_created">
          <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by Date Joined">
            Date Joined
          </th>
          <td mat-cell *matCellDef="let user">
            {{ (user.date_created * 1000) | timezoneConvertShort }} <br>
            {{ (user.date_created * 1000) | timezoneConvertUTCShort }}
          </td>
        </ng-container>

        <ng-container matColumnDef="permissions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
          <td mat-cell *matCellDef="let user">
            <mat-form-field class="my-2" appearance="outline" subscriptSizing="dynamic" style="width: 160px">
              <mat-select
                (selectionChange)="onUpdateUserPermissions(user)"
                [(ngModel)]="user.permissions"
                [ngModelOptions]="{ standalone: true }">
                <mat-option *ngFor="let role of utils.getUserRoles()" [value]="role">{{ role }}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let user">
            <button type="button" mat-button (click)="onDestroyUser(user, $event)">
              Delete
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="usersDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: usersDisplayedColumns"></tr>
      </table>

      <mat-paginator
        [length]="dataSource?.total | async"
        [pageSize]="dataSource.limit"
        [pageSizeOptions]="dataSource.pageSizeOptions"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-tab>

  <mat-tab label="{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Of" *ngIf="account.id">
    <div class="scroll-box">

      <table mat-table [dataSource]="account.contractor_of" #contractorOf>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>
            #
          </th>
          <td mat-cell *matCellDef="let client">
            {{ client.id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            Name
          </th>
          <td mat-cell *matCellDef="let client">
            <a (click)="onRedirectToAccount(client.id)">{{ client.name }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="subscription">
          <th mat-header-cell *matHeaderCellDef>
            Subscription
          </th>
          <td mat-cell *matCellDef="let client">
            {{ client.subscription }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="clientColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: clientColumns"></tr>
      </table>
    </div>
  </mat-tab>

  <mat-tab label="Data Transfer" *ngIf="account.id">
    <app-accounts-data-transfer [accountId]="account.id"></app-accounts-data-transfer>
  </mat-tab>
</mat-tab-group>
